export const QueryCustomerLandingPage = `query QueryCustomerLandingPage($longitude: String!, $latitude: String!, $device: Int!) {
  queryCustomerLandingPage(longitude: $longitude, latitude: $latitude, device: $device) {
    customer {
      _id
      name
      phone
      email
      gender
      nativePlace
      customerType
      isActive
      jwtToken
      refreshToken
      addresses {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      status
      permittedPaymentOptions {
        method
        label
      }
      selectedPaymentMethod
      cart {
        items {
          productId
          skuId
          name
          description
          image
          quantity
          mrp
          status
          prices {
            customerType
            sellingPrice
          }
          measure
          unit
          packingChecked
          billingChecked
        }
        deliveryAddress {
          _id
          deliveryAddress
          details
          label
          selected
          isActive
        }
        billDetails {
          itemsTotal
          deliveryCharge
          couponDiscount
          grandTotal
          totalSaving
          handlingCharge
          itemSavings
          itemsMrp
          chargesWaived
          referralInfo {
            applied
            amount
            code
            message
            referrerId
            percentage
          }
          walletInfo {
            applied
            amount
            message
          }
          couponInfo {
            applied
            amount
            code
            message
            cancellationApplied
          }
          nestInfo {
            applied
            amount
            message
            couponRefundAmount
            couponRefundAccomodated
          }
          cancelledInfo {
            nestInfo {
              applied
              amount
              message
              couponCancellationAmount
              couponCancellationAccomodated
            }
          }
        }
      }
      GST
      onlinePaymentProvider
      favourites
      canApplyReferral
    }
    displayItems {
      displayName
      displayId
      sortOrder
      rows
      columns
      items {
        itemId
        name
        description
        image
        images
        mrp
        prices {
          customerType
          sellingPrice
        }
        discount
        sortOrder
        itemType
        skuId
        outOfStock
        offerEnabled
        offerImage
        measure
        unit
      }
    }
    isLocationServicable
    premiumMembershipMessage
  }
}`

export const ViewCart = `query QueryCartV2($longitude: String!, $latitude: String!) {
  queryCartV2(longitude: $longitude, latitude: $latitude) {
    cart {
      items {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        sellingPrice
        prices {
          customerType
          sellingPrice
        }
        status
        measure
        unit
        packingChecked
        billingChecked
        oldSp
        oldCost
      }
      deliveryAddress {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      billDetails {
        itemsTotal
        deliveryCharge
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
        couponDiscount
        referralInfo {
          applied
          amount
          code
          message
          referrerId
          percentage
        }
        walletInfo {
          applied
          amount
          message
        }
        couponInfo {
          applied
          amount
          code
          message
          cancellationApplied
          limitRate
          daysRange
        }
        nestInfo {
          applied
          amount
          message
          couponRefundAmount
          couponRefundAccomodated
        }
        cancelledInfo {
          nestInfo {
            applied
            amount
            message
            couponCancellationAmount
            couponCancellationAccomodated
          }
        }
        refund
        premiumCustomerSaving
      }
      orderDeliverySlot {
        deliveryString
        slotId
        date
      }
    }
    status
  }
}`

export const QueryDeliveryTimeSlots = `query QueryDeliveryTimeSlots {
  queryDeliveryTimeSlots {
    deliveryString
    slotId
    date
  }
}`

export const QueryCategories = `query QueryCategories($longitude: String!, $latitude: String!, $rows: Int!, $columns: Int!) {
  queryCategories(longitude: $longitude, latitude: $latitude, rows: $rows, columns: $columns) {
    displayName
    sortOrder
    rows
    columns
    items {
      itemId
      name
      description
      image
      images
      mrp
      prices {
        customerType
        sellingPrice
      }
      discount
      sortOrder
      itemType
      skuId
    }
  }
}`

export const QuerySubCategories = `query QuerySubCategories($longitude: String!, $latitude: String!, $rows: Int!, $columns: Int!, $categoryId: String!) {
  querySubCategories(longitude: $longitude, latitude: $latitude, rows: $rows, columns: $columns, categoryId: $categoryId) {
    displayName
    sortOrder
    rows
    columns
    items {
      itemId
      name
      description
      image
      images
      mrp
      prices {
        customerType
        sellingPrice
      }
      discount
      sortOrder
      itemType
      skuId
    }
  }
}`


export const QueryProductsBySubCategory = `query QueryProductsBySubCategory($longitude: String!, $latitude: String!, $rows: Int!, $columns: Int!, $subCategoryId: String!) {
  queryProductsBySubCategory(longitude: $longitude, latitude: $latitude, rows: $rows, columns: $columns, subCategoryId: $subCategoryId) {
    displayItems {
      displayName
      sortOrder
      rows
      columns
      items {
        itemId
        name
        description
        image
        images
        mrp
        prices {
          customerType
          sellingPrice
        }
        discount
        sortOrder
        itemType
        skuId
        outOfStock
        measure
        unit
      }
    }
    isLocationServicable
  }
}`

export const QueryProductsSearch = `query QueryProductsSearch($longitude: String!, $latitude: String!, $text: String!, $skip: Int!, $limit: Int!) {
  queryProductsSearch(longitude: $longitude, latitude: $latitude, text: $text, skip: $skip, limit: $limit) {
    customer {
      _id
      name
      phone
      customerType
      isActive
      jwtToken
      refreshToken
      addresses {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
      status
      permittedPaymentOptions {
        method
        label
      }
      selectedPaymentMethod
      cart {
        items {
          productId
          skuId
          name
          description
          image
          quantity
          mrp
          status
        }
        deliveryAddress {
          _id
          deliveryAddress
          details
          label
          selected
          isActive
        }
        billDetails {
          itemsTotal
          deliveryCharge
          couponDiscount
          grandTotal
          totalSaving
          handlingCharge
          itemSavings
          itemsMrp
        }
      }
    }
    displayItems {
      displayName
      sortOrder
      rows
      columns
      items {
        itemId
        name
        description
        image
        images
        mrp
        prices {
          customerType
          sellingPrice
        }
        discount
        sortOrder
        itemType
        skuId
        outOfStock
        measure
        unit
      }
    }
    isLocationServicable
  }
}`

export const QueryConfirmNewAddress = `query Query($confirmNewAddressInput: ConfirmNewAddressInput) {
  queryConfirmNewAddress(confirmNewAddressInput: $confirmNewAddressInput)
}`;

export const QueryAllOrders = `query QueryAllOrders($limit: Int!, $skip: Int!) {
  queryAllOrders(limit: $limit, skip: $skip) {
    totalCount
    orders {
      _id
      customerId
      orderDate
      deliveryDate
      completionTime
      itemsCount
      orderStatus
      orderAmount
      localStore
      centralStore
      deliveryAddress {
        _id
        location {
          coordinates
        }
        deliveryAddress
        details
        label
        selected
        isActive
      }
    }
  }
}`

export const QueryCustomerAddress = `query QueryCustomerAddress {
  queryCustomerAddress {
    _id
    location {
      coordinates
    }
    deliveryAddress
    details
    label
    selected
    isActive
  }
}`

export const QueryInvoiceByOrderId = `query Query($orderId: String) {
  queryInvoiceByOrderId(orderId: $orderId)
}`

export const GetOrderDetailsById = `query GetOrderDetailsById($orderId: String!) {
  getOrderDetailsById(orderId: $orderId) {
    _id
    items {
      productId
      skuId
      name
      description
      image
      quantity
      mrp
      prices {
        customerType
        sellingPrice
      }
      status
      packingChecked
      billingChecked
    }
    customerType
    customer {
      _id
      name
      phone
      email
      gender
      nativePlace
      customerType
      isActive
      jwtToken
      refreshToken
      addresses {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      status
      permittedPaymentOptions {
        method
        label
      }
      selectedPaymentMethod
      cart {
        items {
          productId
          skuId
          name
          description
          image
          quantity
          mrp
          prices {
            customerType
            sellingPrice
          }
          status
          packingChecked
          billingChecked
        }
        deliveryAddress {
          _id
          location {
            coordinates
          }
          deliveryAddress
          details
          label
          selected
          isActive
        }
        billDetails {
          itemsTotal
          deliveryCharge
          grandTotal
          totalSaving
          handlingCharge
          itemSavings
          itemsMrp
          chargesWaived
          couponDiscount
          walletInfo {
            applied
            amount
            message
          }
          couponInfo {
            applied
            amount
            code
            message
            cancellationApplied
          }
          nestInfo {
            applied
            amount
            message
            couponRefundAmount
            couponRefundAccomodated
          }
          cancelledInfo {
            nestInfo {
              applied
              amount
              message
              couponCancellationAmount
              couponCancellationAccomodated
            }
          }
        }
      }
      GST
      onlinePaymentProvider
      favourites
    }
    paymentStatus
    onlinePaymentStatus
    paymentMethod
    paidAmount
    orderAmount
    orderDate
    deliveryDate
    billDetails {
      itemsTotal
      deliveryCharge
      grandTotal
      totalSaving
      handlingCharge
      itemSavings
      itemsMrp
      chargesWaived
      couponDiscount
      referralInfo {
        applied
        amount
        code
        message
        referrerId
        percentage
      }
      walletInfo {
        applied
        amount
        message
      }
      couponInfo {
        applied
        amount
        code
        message
        cancellationApplied
      }
      nestInfo {
        applied
        amount
        message
        couponRefundAmount
        couponRefundAccomodated
      }
      cancelledInfo {
        nestInfo {
          applied
          amount
          message
          couponCancellationAmount
          couponCancellationAccomodated
        }
      }
    }
    deliveryAddress {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    isOrderModified
    refundStatus
    canceledRefundStatus
    cancelledRefundAmount
    orderState {
      status
      workerStatus
      ppWorkerAssigned
      ppWorkerAssignedEmail
      billingWorkerAssigned
      billingWorkerAssignedEmail
      riderAssigned
      riderAssignedEmail
    }
    invoiceId
    deliveredImage
    customerDeliverySlot {
      name
      leadTime
      timeSlot {
        start
        end
        _id
      }
    }
    deliveryModifications {
      from
      to
      by
      on
      reason
    }
  }
}`;

export const GetModifiedOrderDetails = `query GetModifiedOrderDetails($orderId: String!) {
  getModifiedOrderDetails(orderId: $orderId) {
    _id
    items {
      productId
      skuId
      name
      description
      image
      quantity
      mrp
      prices {
        customerType
        sellingPrice
      }
      status
      packingChecked
      billingChecked
    }
    customer {
      _id
      name
      phone
      email
      gender
      nativePlace
      customerType
      isActive
      jwtToken
      refreshToken
      addresses {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      status
      permittedPaymentOptions {
        method
        label
      }
      selectedPaymentMethod
      GST
      onlinePaymentProvider
      favourites
      canApplyReferral
    }
    paymentStatus
    paymentMethod
    orderStatus
    paidAmount
    orderAmount
    orderDate
    deliveryDate
    billDetails {
      itemsTotal
      deliveryCharge
      grandTotal
      totalSaving
      handlingCharge
      itemSavings
      itemsMrp
      chargesWaived
      couponDiscount
      referralInfo {
        applied
        amount
        code
        message
        referrerId
        percentage
      }
      walletInfo {
        applied
        amount
        message
      }
      couponInfo {
        applied
        amount
        code
        message
        cancellationApplied
      }
      nestInfo {
        applied
        amount
        message
        couponRefundAmount
        couponRefundAccomodated
      }
      cancelledInfo {
        nestInfo {
          applied
          amount
          message
          couponCancellationAmount
          couponCancellationAccomodated
        }
      }
    }
    deliveryAddress {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    isOrderModified
    modifications {
      modifiedBy
      modifiedOn
      originalItems {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        status
        packingChecked
        billingChecked
      }
      modifiedItems {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        status
        packingChecked
        billingChecked
      }
      originalBillDetails {
        itemsTotal
        deliveryCharge
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
        couponDiscount
      }
      modifiedBillDetails {
        itemsTotal
        deliveryCharge
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
        couponDiscount
      }
      instructions
    }
  }
}`;

export const QueryAvailableProducts = `query QueryAvailableProducts($longitude: String!, $latitude: String!, $skip: Int!, $limit: Int!) {
  queryAvailableProducts(longitude: $longitude, latitude: $latitude, skip: $skip, limit: $limit) {
    displayItems {
      displayName
      sortOrder
      rows
      columns
      items {
        itemId
        name
        description
        image
        images
        mrp
        prices {
          customerType
          sellingPrice
        }
        discount
        measure
        unit
        sortOrder
        itemType
        skuId
        outOfStock
      }
    }
    totalCount
    isLocationServicable
  }
}`;

export const QueryOutOfStockProducts = `query QueryOutOfStockProducts($longitude: String!, $latitude: String!, $skip: Int!, $limit: Int!) {
  queryOutOfStockProducts(longitude: $longitude, latitude: $latitude, skip: $skip, limit: $limit) {
    displayItems {
      displayName
      sortOrder
      rows
      columns
      items {
        itemId
        name
        description
        image
        images
        mrp
        prices {
          customerType
          sellingPrice
        }
        discount
        sortOrder
        itemType
        skuId
        measure
        unit
      }
    }
    totalCount
    isLocationServicable
  }
}`

export const QueryProductDetailsByProductId = `query QueryProductDetailsByProductId($latitude: String!, $longitude: String!, $productId: String!) {
  queryProductDetailsByProductId(latitude: $latitude, longitude: $longitude, productId: $productId) {
    _id
    name
    description
    aliases
    images
    defaultImage
    isActive
    category {
      _id
      name
      isActive
      images
      subcategories {
        _id
        name
        description
        isActive
        images
        categoryId
      }
      description
    }
    catalog {
      _id
      name
      description
      isActive
      parcelable
    }
    sortOrder
    hsn
    isNewProduct
    displayName
    sku {
      _id
      productId
      discount
      barcode
      isActive
      mrp
      prices {
        customerType
        sellingPrice
      }
      unit
      measure
    }
    isLocationServicable
    outOfStock
    offerImage
    offerEnabled
  }
}`

export const QueryCatalogProducts = `query QueryCatalogProducts($latitude: String!, $longitude: String!, $catalogId: String!) {
  queryCatalogProducts(latitude: $latitude, longitude: $longitude, catalogId: $catalogId) {
    customerProducts {
      _id
      name
      description
      aliases
      images
      defaultImage
      isActive
      category {
        _id
        name
        isActive
        images
        subcategories {
          _id
          name
          description
          isActive
          images
          categoryId
        }
        description
      }
      catalog {
        _id
        name
        description
        isActive
        parcelable
      }
      sortOrder
      hsn
      isNewProduct
      displayName
      sku {
        _id
        productId
        discount
        barcode
        isActive
        mrp
        prices {
          customerType
          sellingPrice
        }
        unit
        measure
      }
      offerImage
      offerEnabled
    }
    isLocationServicable
  }
}`

export const isLocationAccessible = `query Query($longitude: String!, $latitude: String!) {
  isLocationAccessible(longitude: $longitude, latitude: $latitude)
}`

export const QueryBillingDetails = `query QueryBillingDetails {
  queryBillingDetails {
    itemsTotal
    deliveryCharge
    couponDiscount
    grandTotal
    totalSaving
    handlingCharge
    itemSavings
    itemsMrp
  }
}`

export const QueryOrderTransactionStatus = `query QueryOrderTransactionStatus($transactionId: String!) {
  queryOrderTransactionStatus(transactionId: $transactionId) {
    onlinePaymentStatus
    paymentStatus
    orderId
    orderStatus
    amount
  }
}`

export const QueryAllCustomerTypes = `query GetAllCustomerTypes {
  getAllCustomerTypes {
    name
    _id
    customerType
    description
    charges {
      handling {
        waiverAmount
        rate
      }
      delivery {
        waiverAmount
        rate
      }
    }
    default
  }
}`

export const QueryCustomerDetails = `query QueryCustomer {
  queryCustomer {
    _id
    name
    phone
    email
    gender
    nativePlace
    customerType
    isActive
    jwtToken
    refreshToken
    addresses {
      _id
      location {
        coordinates
      }
      deliveryAddress
      details
      label
      selected
      isActive
    }
    status
    permittedPaymentOptions {
      method
      label
    }
    selectedPaymentMethod
    cart {
      items {
        productId
        skuId
        name
        description
        image
        quantity
        mrp
        prices {
          customerType
          sellingPrice
        }
        status
      }
      deliveryAddress {
        _id
        deliveryAddress
        details
        label
        selected
        isActive
      }
      billDetails {
        itemsTotal
        deliveryCharge
        couponDiscount
        grandTotal
        totalSaving
        handlingCharge
        itemSavings
        itemsMrp
        chargesWaived
      }
    }
    GST
  }
}`

export const QueryNestTransactions = `query QueryNestTransactions($skip: Int!, $limit: Int!) {
  queryNestTransactions(skip: $skip, limit: $limit) {
    customerId
    balance
    transactions {
      _id
      type
      accountingType
      orderId
      amount
      reason
      description
      nestBalance
      createdAt
      expiry
      expired
    }
    createdAt
    expiry
    totalTxnCount
  }
}`

export const QueryReferrelsHistories = `query QueryReferrelsHistories($skip: Int!, $limit: Int!) {
  queryReferrelsHistories(skip: $skip, limit: $limit) {
    referrelsHistory {
      storeId
      code
      type
      referrerName
      referrer
      referrerPhone
      referee
      refereePhone
      refereeName
      orderId
      appliedDate
      registeredDate
      percentageApplied
      redeemedDate
      status
    }
    totalCount
  }
}`

export const QueryFavourites = `query QueryFavourites($longitude: String!, $latitude: String!, $limit: Int!, $skip: Int!) {
  queryFavourites(longitude: $longitude, latitude: $latitude, limit: $limit, skip: $skip) {
    isLocationServicable
    premiumMembershipMessage
    items {
      itemId
      name
      description
      image
      images
      mrp
      prices {
        customerType
        sellingPrice
      }
      discount
      sortOrder
      itemType
      skuId
      outOfStock
      offerEnabled
      offerImage
    }
  }
}`

export const QueryWalletTransactions = `query QueryWalletTransactions($skip: Int!, $limit: Int!) {
  queryWalletTransactions(skip: $skip, limit: $limit) {
    customerId
    balance
    transactions {
      type
      orderId
      amount
      reason
      description
      balance
      createdAt
    }
    createdAt
    totalTxnCount
    message
  }
}`

export const QueryDefaultCustomerType = `query QueryDefaultCustomerType($latitude: String!, $longitude: String!) {
  queryDefaultCustomerType(latitude: $latitude, longitude: $longitude) {
    name
    _id
    customerType
    description
    default
    charges {
      delivery {
        rate
        waiverAmount
      }
      handling {
        rate
        waiverAmount
      }
    }
  }
}`

export const QueryClosestAddressToCurrentLocation = `query QueryClosestAddressToCurrentLocation($longitude: String!, $latitude: String!) {
  queryClosestAddressToCurrentLocation(longitude: $longitude, latitude: $latitude) {
    _id
    location {
      coordinates
    }
    deliveryAddress
    details
    label
    selected
    isActive
  }
}`

export const QueryStoreNestPass = `query QueryStoreNestPass($longitude: String!, $latitude: String!) {
  queryStoreNestPass(longitude: $longitude, latitude: $latitude) {
    code
    regularPurchasePrice
    discountedPurchasePrice
    expiryInMonths
    message
  }
}`

export const QueryNestPassStats = `query QueryNestPassStats {
  queryNestPassStats {
    firstOrderDate
    lastOrderDate
    orderCount
    totalPurchaseAmount
    totalSavedAmount
  }
}`

export const QueryNestPass = `query QueryNestPass($skip: Int!, $limit: Int!) {
  queryNestPass(skip: $skip, limit: $limit) {
    code
    customerId
    customerPhone
    storeId
    firstMembershipDate
    membershipJoinDate
    membershipExpiryDate
    lastMembershipAmount
    lastMembershipUniqueId
    lastMembershipPaymentStatus
    lastMembershipOnlineTransactionId
    isActive
    lastMembershipType
    membershipStatus
    membershipStatusMessage
    refundTxnId
    refundStatus
    lastMembershipInvoiceId
    nestPassMemberships {
      membershipDate
      membershipExpiryDate
      type
      amount
      onlinePaymentProvider
      onlinePaymentStatus
      adminEmail
      cancelRefundPendingAmount
      canceledRefundStatus
      reason
      cancelledBy
      cancelledOn
      invoiceId
      internalId
    }
    nestPassMembershipCount
  }
}`

export const QueryNestPassInvoice = `query Query($invoiceId: String!) {
  queryInvoiceForNestPass(invoiceId: $invoiceId)
}`